'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors = {
  black: '#000',
  white: '#FFF',
  blue: '#0192cc',
  darkBlue: '#263746',
  lightGray: '#eaeaea',
  gray: '#d1d3d3',
  darkGray: '#b7b7b7',
  charcoal: '#666666',
  red: '#c3002f',
  darkRed: '#a41f35',
  yellow: '#ffbb2b',
  gradientStart: '#747e82',
  green: '#008000'
};

var breakpoints = {
  xs: '320px',
  s: '480px',
  m: '720px',
  l: '900px',
  xl: '1200px',
  xxl: '1600px',
  xxxl: '2000px'
};

var typography = {
  baseFontSize: '16px',
  baseLineHeight: '1.4em'
};

var stickyHeader = {
  stickyHeaderHeight: '47px',
  stickyAlertHeight: '100px'
};

exports.colors = colors;
exports.breakpoints = breakpoints;
exports.stickyHeader = stickyHeader;
exports.typography = typography;